import { LiftRange } from '../types';

/**
 * Parse a lift percentage string into min, max, and average values
 * @param str - String like "2-5%" or "3%"
 * @returns Object with min, max, and avg values
 */
export const parseLiftRange = (str: string): LiftRange => {
  if (!str) return { min: 0, max: 0, avg: 0 };

  const nums = str.replace(/[%\s]/g, '').split(/[-–]/).map(Number);

  if (nums.length === 1) {
    return { min: nums[0], max: nums[0], avg: nums[0] };
  }

  const min = Math.min(...nums);
  const max = Math.max(...nums);

  return { min, max, avg: (min + max) / 2 };
};

/**
 * Calculate overall score from an array of scores
 * @param scores - Array of numeric scores
 * @returns Average score, or 100 if no scores provided
 */
export const calcOverall = (scores: number[]): number => {
  return scores.length
    ? Math.round(scores.reduce((sum, val) => sum + val, 0) / scores.length)
    : 100;
};